import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { ContentWithCardLoading } from "../../../../components/loading";
import AdvanceDataTable from "../../../../components/normal-table/advance-table";
import * as accountCampaignPricingEmailActions from "../../store/actions/account_campaign_pricing_email_actions";
import AccountCampaignPricingEmailSidePanel from "./components/account-campaign-pricing-email-side-panel";

const ACCOUNT_CAMPAIGN_PRICING_EMAIL_ACTIONS = {
  NONE: "NONE",
  EDIT: "EDIT",
};

export default function AccountCampaignPricingEmail() {
  const [selectedPricingWithAction, setSelectedPricingWithAction] = useState({
    action: ACCOUNT_CAMPAIGN_PRICING_EMAIL_ACTIONS.NONE,
    data: {},
  });
  const accountCampaignPricingEmailList = useSelector((state) => state.accounts.accountCampaignPricingEmail);
  const params = useParams();

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(accountCampaignPricingEmailActions.getPricingOfAccountEmailCampaignRequest({ id: params.accountId }));
  }, [dispatch, params.accountId]);

  return (
    <>
      {accountCampaignPricingEmailList.loading ? (
        <ContentWithCardLoading />
      ) : accountCampaignPricingEmailList.data.length === 0 ? (
        "No accounts"
      ) : (
        // <CustomEmptyPage
        //   page="blockContact"
        //   setShowAdd={() =>  {
        //     setShow(true);
        //     setIsEdit(false);
        //   }}
        // />
        <div className={`card card-custom`}>
          <div className="card-body py-3 px-3" style={{ padding: 15 }}>
            <AdvanceDataTable
              columns={[
                { title: "Currency", apiKeyName: "currency", fieldInputType: "INPUT" },
                { title: "Price Per Email", apiKeyName: "price", fieldInputType: "INPUT" },
                { title: "Additional Price Per Email", apiKeyName: "addOnPrice", fieldInputType: "INPUT" },
                { title: "Attachment Price Per Email ", apiKeyName: "attachmentPrice", fieldInputType: "INPUT" },
                { title: "Additional Attachment Price Per Email", apiKeyName: "addOnAttachmentPrice", fieldInputType: "INPUT" },
                { title: "Final Price Per Email ", apiKeyName: "finalPrice", fieldInputType: "INPUT" },
                { title: "Final Attachment Price Per Email", apiKeyName: "finalAttachmentPrice", fieldInputType: "INPUT" },
                { title: "Actions", isAction: true, options: ["edit"] },
              ]}
              data={accountCampaignPricingEmailList.data.map((each) => ({
                ...each,
                finalPrice: ((each.addOnPrice || 0) + (each.price || 0)).toFixed(4),
                finalAttachmentPrice: ((each.addOnAttachmentPrice || 0) + (each.attachmentPrice || 0)).toFixed(4),
              }))}
              limit={10}
              pageNo={1}
              count={1}
              // actions
              handleEdit={(data) => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_EMAIL_ACTIONS.EDIT, data })}
            />
          </div>
        </div>
      )}

      <AccountCampaignPricingEmailSidePanel
        show={selectedPricingWithAction.action === ACCOUNT_CAMPAIGN_PRICING_EMAIL_ACTIONS.EDIT}
        pricingData={selectedPricingWithAction.data}
        handleClose={() => setSelectedPricingWithAction({ action: ACCOUNT_CAMPAIGN_PRICING_EMAIL_ACTIONS.NONE, data: {} })}
      />
    </>
  );
}
